<template>
    <div>
      <feather-icon v-if="params.value" :icon="icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="clicked" />
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: 'CellRendererDownload',
  computed: {
    icon () {
      let { icon } = this.params;
      icon = (icon) ? icon : 'FileTextIcon';

      return icon;
    }
  },
  methods: {
    clicked() {
      const { data } = this.params;

      this.$parent.$emit('download', data);
    }
  }
});
</script>
